import STMypageBoardList from "../../assets/styles/organisms/myPageBoardList.module.scss";
import Pagenation from "./AppPagenation";
import { useContext, useEffect, useMemo, useState } from "react";
import BoardCard, { BoardItem } from "./BoardCard";
import { SiteContext } from "../../providers/SiteProvider";
import { fetchMyBoards } from "../../utils/api/fetchMyBoards";
import { GetMyPageBoardsResponse } from "../../api/board";
import { useLocation } from "react-router-dom";
import TPager from "../../types/TAppPager";
import { fetchMyActivityBoards } from "../../utils/api/fetchMyActivityBoards";
import { CircularProgress } from "@material-ui/core";
import { useIsMobile } from "../../hooks/useIsMobile";
import InfiniteScroll from "../organisms/my_page/message_board/InfiniteScroll";

const LIMIT_PER_PAGE_PC = 8;
const LIMIT_PER_PAGE_SP = 10;
interface MypageBoardListProps {
  isMyBoard?: boolean;
}
const MypageBoardList: React.FC<MypageBoardListProps> = (props) => {
  const { isMyBoard = false } = props;
  const { isMobile } = useIsMobile();
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const page = query.get("page") ? Number(query.get("page")) : 1;

  // sp
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [offset, setOffset] = useState<number>(0);

  // pc
  const [refresh, setRefresh] = useState(0);

  const [total, setTotal] = useState<number>(0);
  const [boards, setBoards] = useState<BoardItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const mainColor = useContext(SiteContext).mainColor;
  const pager = useMemo(
    () => new TPager(page, total, LIMIT_PER_PAGE_PC),
    [page, total]
  );
  const getUrlPath = () => {
    const params = new URLSearchParams(location.search);
    params.delete("page");
    const newSearch = params.toString();
    const newPath = `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;

    return newPath;
  };
  const onDeleteSuccessMobile = (boardId: number) => {
    setBoards((prev) => prev.filter((board) => board.id !== boardId));
    setTotal((prev) => prev - 1);
  };

  useEffect(() => {
    setIsLoading(true);
    let fetchFunction;
    if (isMyBoard) {
      fetchFunction = fetchMyBoards;
    } else {
      fetchFunction = fetchMyActivityBoards;
    }
    const param = isMobile
      ? {
          limit: LIMIT_PER_PAGE_SP,
          offset: offset,
        }
      : {
          limit: LIMIT_PER_PAGE_PC,
          page: page,
        };
    fetchFunction(param)
      .then((res: GetMyPageBoardsResponse) => {
        if (!res.data) return;
        setTotal(res.total);
        const boards: BoardItem[] = (res.data || []).map((board: any) => {
          return {
            id: board.id,
            nickname: board.nickname,
            avatarUrl: board.avatar_url,
            title: board.title,
            content: board.content,
            createdAt: board.created_at,
            likeCount: board.total_of_likes,
            likeFlag: board.like_flag,
            commentCount: board.total_of_comments,
            imageUrls: board.image_urls,
            categoryId: board.board_category_id,
            status: board.status,
            isPublic: board.is_public,
            commentFlag: board.comment_flag,
          };
        });
        if (isMobile) {
          if (boards.length === 0) {
            setHasMore(false);
          } else {
            setBoards((prev) => {
              const oldBoards = prev.filter((board) => {
                return !boards.some((newBoard) => newBoard.id === board.id);
              });
              return [...oldBoards, ...boards];
            });
          }
        } else {
          setBoards(boards);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [page, offset, refresh]);

  return (
    <>
      {!isMobile ? (
        <>
          {isLoading ? (
            <div style={{ width: "100%", height: "100%", textAlign: "center" }}>
              <CircularProgress
                color="inherit"
                size={25}
                disableShrink
                style={{ marginRight: 8 }}
              />
            </div>
          ) : boards.length === 0 ? (
            <div style={{ textAlign: "center" }}>
              <p>現在コメント/いいね投稿がございません</p>
            </div>
          ) : (
            <div className={STMypageBoardList.grid_container}>
              {boards.map((board) => (
                <BoardCard
                  key={board.id}
                  boardDetail={board}
                  isMyBoard={isMyBoard}
                  isMyActivityBoard={!isMyBoard}
                  onDeleteSuccess={() => setRefresh(refresh + 1)}
                />
              ))}
            </div>
          )}

          {boards.length > 0 && (
            <Pagenation
              className=""
              urlPath={getUrlPath()}
              total={total}
              start={1}
              end={pager.max}
              current={page}
            />
          )}
        </>
      ) : (
        <>
          {!isLoading && boards.length === 0 && (
            <div style={{ textAlign: "center" }}>
              <p>現在コメント/いいね投稿がございません</p>
            </div>
          )}
          <InfiniteScroll
            fetchMoreData={() => setOffset(boards.length)}
            hasMore={boards.length < total && hasMore}
            loading={isLoading}
          >
            <div className={STMypageBoardList.grid_container_mobile}>
              {boards.map((board) => (
                <BoardCard
                  key={board.id}
                  boardDetail={board}
                  isMyBoard={isMyBoard}
                  isMyActivityBoard={!isMyBoard}
                  onDeleteSuccess={() => onDeleteSuccessMobile(board.id)}
                />
              ))}
            </div>
          </InfiniteScroll>
        </>
      )}
    </>
  );
};

export default MypageBoardList;
